import AjaxRequest from './AjaxRequest';

export default class Package
{
    getAll(data) {
        return new AjaxRequest().get('packages', data);
    }

    getDetails(pkg_no, data) {
        return new AjaxRequest().get(`packages/${pkg_no}`, data);
    }

    getSheets(pkg_no, data) {
        return new AjaxRequest().get(`packages/${pkg_no}/sheets`, data);
    }

    getPoseLimit(pkg_no, data) {
        return new AjaxRequest().get(`packages/${pkg_no}/poselimit`, data);
    }

    getPrice(pkg_no, data) {
        return new AjaxRequest().get(`packages/${pkg_no}/price`, data);
    }

    getRecommended(data) {
        return new AjaxRequest().get('packages/recommended', data);
    }

    getAddons(data) {
        return new AjaxRequest().get('packages/addons', data);
    }
}
